namespace TabAurous.Inventory {
    export interface MaterialReceiptItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        PartyId: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        DesignId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: Serenity.LookupEditor;
        Attribute: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        MetalColorId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        CalcOnId: Serenity.LookupEditor;
        CalcUnitId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        UnitRate: Serenity.DecimalEditor;
        StoneRate: AmountEditor;
        OtherRate: AmountEditor;
        NetAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        Line_No: Serenity.StringEditor;
        HSN: Serenity.LookupEditor;
        TaxCode: Serenity.LookupEditor;
        NetWeight: WeightEditor;
        DepartmentId: Serenity.IntegerEditor;
        Remarks: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        ServerDate: Serenity.DateEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
        CostMethodId: Serenity.LookupEditor;
        ImageName: Serenity.StringEditor;
        Studded: Serenity.IntegerEditor;
    }

    export class MaterialReceiptItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.MaterialReceiptItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MaterialReceiptItemsForm.init)  {
                MaterialReceiptItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = s.DecimalEditor;
                var w5 = WeightEditor;
                var w6 = StoneSieveLookup;
                var w7 = AmountEditor;
                var w8 = s.BooleanEditor;
                var w9 = s.DateEditor;

                Q.initFormType(MaterialReceiptItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'PartyId', w1,
                    'BagNo', w0,
                    'SKU', w0,
                    'RefNo', w0,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'DesignId', w0,
                    'ProductTypeId', w2,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'DesignCode', w0,
                    'AttributeId', w0,
                    'CategoryId', w3,
                    'SubCategoryId', w2,
                    'Attribute', w0,
                    'KaratId', w2,
                    'Purity', w4,
                    'PureWeight', w5,
                    'MetalColorId', w2,
                    'ShapeId', w2,
                    'StoneColorId', w2,
                    'QualityId', w2,
                    'StoneSizeId', w2,
                    'SieveId', w6,
                    'GroupSieveId', w6,
                    'StoneCutId', w2,
                    'StonePolishId', w2,
                    'StoneSymmetryId', w2,
                    'StoneFluorescenceId', w2,
                    'StoneCuletId', w2,
                    'StoneGirdleId', w2,
                    'StoneTable', w0,
                    'StoneDepth', w0,
                    'LotNo', w0,
                    'Lab', w2,
                    'CertificateNo', w0,
                    'CalcOnId', w2,
                    'CalcUnitId', w2,
                    'Pieces', w1,
                    'Weight', w5,
                    'UnitRate', w4,
                    'StoneRate', w7,
                    'OtherRate', w7,
                    'NetAmount', w4,
                    'GrossAmount', w4,
                    'CCNetAmount', w4,
                    'CCGrossAmount', w4,
                    'Line_No', w0,
                    'HSN', w2,
                    'TaxCode', w2,
                    'NetWeight', w5,
                    'DepartmentId', w1,
                    'Remarks', w0,
                    'IsDisabled', w8,
                    'ServerDate', w9,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w9,
                    'CompanyId', w1,
                    'BagStatus', w0,
                    'CostMethodId', w2,
                    'ImageName', w0,
                    'Studded', w1
                ]);
            }
        }
    }
}
